var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreTiming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#EF7016"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4917 21.9949L20.4317 19.9649V13.6416L20.42 13.5133C20.35 12.9649 19.8834 12.5449 19.3234 12.5449C18.7167 12.5449 18.215 13.0466 18.215 13.6533V20.6649L18.2267 20.8166C18.285 21.1666 18.5067 21.4816 18.8334 21.6449L23.5117 23.9783L23.6284 24.0249C23.745 24.0716 23.8734 24.0833 23.99 24.0833C24.3984 24.0833 24.795 23.8499 24.9817 23.4649L25.0284 23.3483C25.2267 22.8233 24.9934 22.2399 24.4917 21.9949Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9417 7.16699C12.895 7.16699 7.16669 12.8953 7.16669 19.942C7.16669 26.9887 12.895 32.717 19.9417 32.717C26.9884 32.717 32.7167 26.9887 32.7167 19.942C32.7167 12.8953 26.9884 7.16699 19.9417 7.16699ZM30.5 19.942C30.5 25.7637 25.7634 30.5003 19.9417 30.5003C14.12 30.5003 9.38335 25.7637 9.38335 19.942C9.38335 14.1203 14.12 9.38366 19.9417 9.38366C25.7634 9.38366 30.5 14.1203 30.5 19.942Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreTiming);
export default __webpack_public_path__ + "static/media/store-timing.e356b827ceb9ddd8decbf8c0c68966ff.svg";
export { ForwardRef as ReactComponent };